import {
  Typography,
  Avatar,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
} from "@mui/material";
import React from "react";
import WarningIcon from "@mui/icons-material/Warning";
import CircleIcon from "@mui/icons-material/Circle";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import ErrorIcon from "@mui/icons-material/Error";
import { DataGrid } from "@mui/x-data-grid";
import "./LogisticsScreen.css";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import API from "../API";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";

const VEHICLE_NAMES = {
  0: "Motor",
  2: "Doblo",
  3: "Minivan",
  4: "Panelvan",
  5: "Kamyonet",
  7: "Kamyon (6 Teker)",
  8: "Kamyon (8 Teker)",
  9: "Kamyon (10 Teker)",
};
const cityOptions = Object.values(API.allowedCities || {}).map((city) => ({
  label: city.name,
  value: city.id,
}));
const defaultCityFilter = cityOptions.map((city) => city.value);
const vehicleOptions = Object.entries(VEHICLE_NAMES).map(([value, label]) => ({
  label,
  value: Number(value),
}));
const defaultVehicleFilter = vehicleOptions.map((vehicle) => vehicle.value);
export default class DriversScreen extends React.Component {
  constructor() {
    super();

    this.state = {
      drivers: [],
      cityFilter: defaultCityFilter,
      vehicleFilter: defaultVehicleFilter,
      driverCount: 0,
      verifiedOnly: false,
      validOnly: false,
    };
  }

  componentDidMount() {
    this.getDriverList();
  }

  getDriverList(page) {
    API.fetch("getdrivers", {
      page,
      cityFilter: this.state.cityFilter,
      vehicleFilter: this.state.vehicleFilter,
      verifiedOnly: this.state.verifiedOnly,
      validOnly: this.state.validOnly,
    }).then((e) => {
      if (e.driverCount) this.state.driverCount = e.driverCount;

      this.setState({ drivers: e.drivers });
    });
  }
  render() {
    return (
      <div>
        <div>
          <FormGroup
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 16,
            }}
          >
            <FormControl fullWidth>
              <InputLabel>Şehir</InputLabel>
              <Select
                multiple
                value={this.state.cityFilter}
                onChange={(e) => {
                  this.setState({ cityFilter: e.target.value }, () =>
                    this.getDriverList()
                  );
                }}
                input={<OutlinedInput label="Şehir" />}
                renderValue={(selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={
                          cityOptions.find((x) => x.value === value)?.label
                        }
                      />
                    ))}
                  </div>
                )}
              >
                {cityOptions.map((city) => (
                  <MenuItem key={city.value} value={city.value}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {/* Label */}
                      <span style={{ flexGrow: 1 }}>{city.label}</span>

                      {/* Check icon only if selected */}
                      {this.state.cityFilter.includes(city.value) && (
                        <CheckIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                      )}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Araç Tipi</InputLabel>
              <Select
                multiple
                value={this.state.vehicleFilter}
                onChange={(e) => {
                  this.setState({ vehicleFilter: e.target.value }, () =>
                    this.getDriverList()
                  );
                }}
                input={<OutlinedInput label="Araç Tipi" />}
                renderValue={(selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={
                          vehicleOptions.find((x) => x.value === value)?.label
                        }
                      />
                    ))}
                  </div>
                )}
              >
                {vehicleOptions.map((vehicle) => (
                  <MenuItem key={vehicle.value} value={vehicle.value}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <span style={{ flexGrow: 1 }}>{vehicle.label}</span>
                      {this.state.vehicleFilter.includes(vehicle.value) && (
                        <CheckIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                      )}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    this.setState(
                      { verifiedOnly: e.target.checked },
                      () => this.getDriverList()
                    );
                  }}
                />
              }
              label="Onay Bekliyor"
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    this.setState(
                      { validOnly: e.target.checked },
                      () => this.getDriverList()
                    );
                  }}
                />
              }
              label="Onaylanmış"
            />
          </FormGroup>
        </div>

        <Badge style={{ marginTop: 50, padding: 0 }}>
          <div style={{ padding: 24 }}>
            <Typography variant="h5">Sürücü Listesi</Typography>
          </div>
          <DataGrid
            autoHeight
            rows={this.state.drivers.map((x, i) => ({ ...x, id: i }))}
            columns={[
              {
                field: "Ad Soyad",
                flex: 1,
                renderCell: (params) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      src={
                        "https://ik.imagekit.io/tasimacim/driver/tr:w-80/" +
                        params.row._id +
                        ".jpeg"
                      }
                    />{" "}
                    {/*src={"https://tasimacim-driver-pictures.s3.eu-central-1.amazonaws.com/"+params.row._id+".jpeg"}*/}
                    <div style={{ marginLeft: 10 }}>
                      <Typography variant="body1">{params.row.name}</Typography>
                      <Typography variant="body2">
                        {params.row.email}
                      </Typography>
                    </div>
                  </div>
                ),
              },
              {
                field: "Araç",
                flex: 1,
                valueGetter: (params, row) =>
                  row.vehicles
                    .map((x) => VEHICLE_NAMES[x.type])
                    .filter(Boolean)
                    .join(", "),
              },
              {
                field: "Şehir",
                flex: 1,
                valueGetter: (params, row) => API.getCityName(row.city),
              },
              {
                field: "Telefon",
                flex: 1,
                valueGetter: (params, row) => row.phone,
              },
              {
                field: " ",
                renderCell: (params) => {
                  return (
                    <a href={"../driver/" + params.row._id}>
                      <Button>
                        <ArrowForwardIcon />
                      </Button>
                    </a>
                  );
                  // return <Link to={'/driver/' + params.row._id} ><Button><ArrowForwardIcon /></Button></Link>
                },
              },
            ]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            onPaginationModelChange={(model) => {
              // this.setState({drivers: []});
              this.getDriverList(model.page);
            }}
            pageSizeOptions={[50]}
            slotProps={{
              pagination: { showFirstButton: true, showLastButton: true },
            }}
            rowCount={this.state.driverCount}
            paginationMode="server"
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#F3F4F6",
                borderRadius: 0,
              },
            }}
          />
        </Badge>
      </div>
    );
  }
}

const Badge = (props) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        boxShadow:
          "rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px",
        borderRadius: 8,
        padding: 24,
        color: "rgb(18, 24, 40)",
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
